import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Entities } from '@jessie/commons';
import { NgIconWrapperComponent } from './ng-icon-wrapper/ng-icon-wrapper.component';


@Component({
    selector: 'app-entity-icon',
    templateUrl: './entity-icon.component.html',
    imports: [NgIconWrapperComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityIconComponent {
  @Input()
  entity!: Entities;
}
